import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type TimeBadgeConfig } from './time-badge.types';

@Component({
  selector: 'app-time-badge',
  templateUrl: './time-badge.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dynamic],
})
export class TimeBadge {
  readonly config = input.required<TimeBadgeConfig>();

  protected readonly timeTextConfig = computed(() => ({
    text: this.config().time,
    size: 'base',
    fontWeight: 'semibold',
    color: 'var(--timebadge-color)',
  }));

  protected readonly labelTextConfig = computed(() => ({
    text: this.config().label,
    size: 'xs',
    fontWeight: 'bold',
    color: 'var(--timebadge-color)',
  }));
}
